import axios from 'axios'

import { Config, Header as HeaderPlain } from '../../config.api'

const Header = async () => {
  const header = await HeaderPlain()
  header.headers['by-pass'] = true
  return header
}

const GetDashboardBerthingManagement = async ({ skip, take, filters }) => {
  try {
    const response = await axios.get(
      `${Config.MAIN_SERVICE_ENDPOINT}/service_request/berthing?skip=${skip}&take=${take}&filter=${filters}`,
      await Header()
    )
    return response.data
  } catch (error) {
    return error
  }
}

export default {
  GetDashboardBerthingManagement
}
